var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HorizontalBarChart',{attrs:{"title":_vm.title,"data":_vm.data,"labels":_vm.labels}})
}
var staticRenderFns = []

export { render, staticRenderFns }